(function () {
  var guardedPath = '/products/the-northerner-helmet-camo-scrim';

  if (window.location.pathname !== guardedPath || window.NutsofGloboGuard) return;
  window.NutsofGloboGuard = true;

  var root = document.documentElement;
  var style = document.createElement('style');
  style.id = 'nutsof-globo-options-guard-style';
  style.textContent =
    '.template-product.nutsof-gpo-loading .product-form__submit{' +
    'pointer-events:none!important;opacity:.6!important;cursor:wait!important;' +
    '}';
  document.head.appendChild(style);
  root.classList.add('nutsof-gpo-loading');

  var released = false;
  var observer;

  function setButtonsDisabled(disabled) {
    document.querySelectorAll('.product-form__submit').forEach(function (button) {
      if (disabled) {
        if (!button.dataset.nutsofGpoGuard) {
          button.dataset.nutsofGpoWasDisabled = String(button.disabled);
        }
        button.disabled = true;
        button.setAttribute('aria-disabled', 'true');
        button.dataset.nutsofGpoGuard = 'true';
      } else if (button.dataset.nutsofGpoGuard === 'true') {
        button.disabled = button.dataset.nutsofGpoWasDisabled === 'true';
        if (!button.disabled) button.removeAttribute('aria-disabled');
        delete button.dataset.nutsofGpoGuard;
        delete button.dataset.nutsofGpoWasDisabled;
      }
    });
  }

  function release() {
    if (released) return;
    released = true;
    root.classList.remove('nutsof-gpo-loading');
    setButtonsDisabled(false);
    if (observer) observer.disconnect();
  }

  function optionsReady() {
    return Boolean(document.querySelector('.gpo-app .gpo-label, .gpo-app .gpo-element'));
  }

  observer = new MutationObserver(function () {
    setButtonsDisabled(true);
    if (optionsReady()) release();
  });
  observer.observe(document.documentElement, { childList: true, subtree: true });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      setButtonsDisabled(true);
      if (optionsReady()) release();
    }, { once: true });
  } else {
    setButtonsDisabled(true);
    if (optionsReady()) release();
  }

  window.setTimeout(release, 5000);
})();
